import { render, staticRenderFns } from "./ProjectLogsPage.vue?vue&type=template&id=678650fd"
import script from "./ProjectLogsPage.vue?vue&type=script&lang=js"
export * from "./ProjectLogsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports